"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="llamado-a-la-acción" ref={ref} className={cn("py-12 md:py-9 lg:py-12 bg-background text-foreground transition-opacity duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
      <div className="container max-w-6xl mx-auto px-4 text-center">
        {}
        <p className="font-sans text-[0.875rem] uppercase tracking-[0.15em] mb-8 text-foreground/80">
          Contacta con nosotros
        </p>

        {}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
          <Button asChild className="bg-primary text-secondary hover:bg-primary-600 rounded-lg px-10 py-2 h-auto text-base font-semibold font-sans transition-colors duration-300">
            <Link to="/HayaTastingPage">
              Catas en La Haya
            </Link>
          </Button>

          <Button asChild className="bg-primary text-secondary hover:bg-primary-600 rounded-lg px-10 py-2 h-auto text-base font-semibold font-sans transition-colors duration-300">
            <Link to="/ForStoresPage">
              Información para tiendas
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}